
<q-card class="cmp-properties-summary ws-card q-pa-lg">
  <h6 class="q-mb-md">
    {{ $t(title) }}
  </h6>
  <q-skeleton v-if="loading" type="QRange" animation="fade" height="100px" />
  <template v-else>
    <div class="item text-ws-base110 q-pa-md">
      <div class="title-wrapper relative-position">
        <price-period
          class="float-right q-ml-md"
          :period-under="!!$slots.info"
          :prices="info.prices"
          :price="info.price"
          :period="period"
        />
        <small class="text-bold text-ws-base140">{{
          info.title ? $t(info.title) : info.brand
        }}</small>
      </div>
      <div v-if="$slots.info" class="secondary q-mt-sm">
        <slot name="info"></slot>
        <div v-if="$slots['info-secondary']">
          <slot name="info-secondary"></slot>
        </div>
      </div>
    </div>

    <ws-list
      v-if="items.length"
      class="q-ml-xs q-mt-md q-mb-xl"
      :items="items"
    >
      <template v-slot="scope">
        <small class="q-pl-sm inline-block full-width">
          <price-period
            v-if="!simpleItems"
            class="float-right q-ml-md"
            :price="scope.item.i_price"
            individual
            :period="period"
          />
          {{ getItemLabel(scope) }}
        </small>
      </template>
    </ws-list>
    <slot v-else name="empty"></slot>
  </template>

  <hr class="ws-default q-mt-xl q-mb-md" />
  <table class="price-table" cellspacing="0" cellpadding="0" width="100%">
    <tfoot class="total">
      <tr>
        <td class="text">
          <small>{{ $t('summary.sum') }}:</small>
        </td>
        <td class="price text-right">
          <price-period individual :price="totalPrice" :period="period" />
        </td>
      </tr>
    </tfoot>
  </table>

  <slot></slot>
</q-card>
